
import { Spin, Tree, Avatar, Input, Empty, Button, Tooltip } from 'antd';
import React, { Children } from 'react';
import _ from 'lodash';
import { api, app, config, use } from 'xadmin';
import { Icon } from 'xadmin-ui';
import { formatDepartment } from '../components/util'
import SelectDepartment, { filterDepartment } from './SelectDepartment'
import './NodeTreeSelect.css'

const { Search } = Input

const NodeTree = props => {
  const { model, input, selectDepartment, style, isShowAll, isExpandAll, isPoint, single, editMode, cellKey, _treeData, _nodeList, _departmentPath } = props
  const [editable, setEditable] = React.useState(editMode ? false : true)
  const [state, set] = React.useState({
    models: [],
    nodes: {},
    treeData: _treeData || [],
    loading: false,
    current: []
  })
  const { models, treeData, loading, current } = state
  const setState = props => set({ ...state, ...props })
  const [ready, setReady] = React.useState(false)
  const [nodes, setNodes] = React.useState(true)
  const [tags, setTags] = React.useState([])
  const [defaultCheckedKeys, setDefaultCheckedKeys] = React.useState([])
  const [expandedKeys, setExpandedKeys] = React.useState([])
  const [autoExpandParent, setAutoExpandParent] = React.useState(isExpandAll)
  const [department, setDepartment] = React.useState([])
  const formProps = use('dashboard.from')
  const { mergeParams, deleteParams } = formProps

  const { onlineText = '#fff', onlinebackground = '#00bc00', offlineText = '#fff', offlinebackground = '#ff3030' } = style || {}
  const iconStyle = {
    width: 28,
    height: 20,
    lineHeight: '20px',
    display: 'inline-block',
    marginRight: 3,
    borderRadius: 5,
    // color: '#fff',
    fontSize: 12,
    // transform: 'scale(0.6,0.6)'
  }
  const offlineStyle = {
    color: offlineText,
    background: offlinebackground
  }
  const onlineStyle = {
    color: onlineText,
    background: onlinebackground
  }

  const fetchNodes = () => {
    return new Promise((resolve, reject) => {
      const where = {}
      if (model && model.length) {
        where['modelId'] = { $in: model.map(item => item.id) }
      }
      api(app.get('models').Node)
        .query({ fields: ['modelId', 'icon', 'model.icon', 'department', 'gis', 'online'] }, { where })
        .then(({ items }) => {
          // dataRef.children = dataFun(items, dataRef.id)
          const nodes = items.reduce((prev, item) => ({ ...prev, [item.id]: item }), {})
          setNodes(nodes)
          resolve(nodes)
        })
    })
  }
  const setData = (data) => {
    return data?.map(item => {

      const icon = !item?.isNode ? <Icon svg={require('./../icon/DepartmentDark.svg')} /> : (
        <div style={{ width: 50, display: 'inline-block' }}>
          <div style={{ ...(item.online ? onlineStyle : offlineStyle), ...iconStyle }}>{item.online ? '在线' : '离线'}</div>
          <Icon svg={require('./../icon/NodeDark.svg')} />
        </div>
      )
      if (item?.children) {
        return {
          ...item,
          icon,
          children: setData(item.children)
        }
      } else {
        const temp = {
          ...item,
          isLeaf: isPoint ? false : true,
          selectable: isPoint ? false : true,
          icon
        }
        if (_.isUndefined(item.isLeaf)) delete temp.isLeaf
        if (_.isUndefined(item.selectable)) delete temp.selectable
        return temp
      }
    })
  }
  const setDep = (data, path) => {
    return path.map(item => data.filter(ele => ele?.id == item)[0])
  }

  const mergeTreeData = (data, nodelist, noDepNodeList) => {
    return data?.map(treenode => {
      if (!treenode?.isNode) {
        const nodesFilter = nodelist.filter(item => item?.department[0]?.id === treenode.id).map(item => {
          return {
            ...item,
            title: item.name,
            key: item.id + '_' + Math.random() * 10,
            isLeaf: isPoint ? false : true,
            isNode: true,
            selectable: isPoint ? false : true
          }
        })
        return {
          ...treenode,
          children: [
            ...(mergeTreeData(treenode.children, nodelist) || []),
            ...nodesFilter,
            ...(treenode?.id == 'all' ? noDepNodeList : [])
          ].filter(item => {
            if (treenode?.id == 'all') {
              if (isShowAll) return true
              if (!isShowAll) return !item?.isNode
            }
            return true
          })
        }
      } else if (treenode?.isNode) {
        return treenode
      }
    })
  }

  const fetchDepartment = (nodes, isPoint) => {
    return new Promise((resolve, reject) => {
      setState({ loading: true })
      const schema = app.get('models')['Department']
      api(schema)
        .query({ fields: ['name', 'parent'] })
        .then(({ items }) => {
          if (items && !_.isEmpty(items)) {
            // setDep(items, _departmentPath)
            const selectItems = filterDepartment(props?._departmentPath ? _.compact(setDep(items, _.union(_departmentPath, selectDepartment))) : items, selectDepartment)
            // const selectItems = filterDepartment(items, selectDepartment)
            setDepartment(items)
            // setDepartment(items)
            const _department = formatDepartment(selectItems)
            const nodesList = _.keys(nodes).map(key => nodes[key])
            const noDepNodeList = _.filter(nodesList, (item) => _.isEmpty(item.department)).map(item => {
              return {
                ...item,
                title: item.name,
                key: item.id + '_' + Math.random() * 10,
                showicon: true,
                isLeaf: isPoint ? false : true,
                icon: <div style={{ width: 50, display: 'inline-block' }}>
                  {
                    <div style={{ ...(item.online ? onlineStyle : offlineStyle), ...iconStyle }}>{item.online ? '在线' : '离线'}</div>
                  }
                  <Icon svg={require('./../icon/NodeDark.svg')} />
                </div>,
                isNode: true,
                selectable: isPoint ? false : true
              }
            })
            const treeData = isShowAll ? [...insertNodes(_department, nodesList, isPoint), ...noDepNodeList] : insertNodes(_department, nodesList, isPoint)

            const _defaultCheckedKeys = getDefaultCheckedKeys(_treeData ? setData(_treeData) : treeData, nodes)
            setDefaultCheckedKeys(_defaultCheckedKeys)
            setExpandedKeys(isExpandAll ? selectItems.map(item=>item.id) : [])
            setState({
              models: selectItems,
              treeData: (_treeData || window[cellKey + '_treeData']) ? setData(mergeTreeData((_treeData || window[cellKey + '_treeData']), nodesList, noDepNodeList)) : [{
                fullName: "全部",
                id: "all",
                key: "all",
                name: "全部",
                node: undefined,
                parent: {},
                title: "全部",
                uid: "all",
                users: undefined,
                children: treeData
              }],
              loading: false
            })
            resolve()
          }
          setReady(true)
        })
    })
  }

  const getDefaultCheckedKeys = (treeData, nodes) => {
    for (let item of treeData) {
      if (item.isNode) {
        if (input && input.onChange) input.onChange([nodes[item.id]])
        return [item.key]
      }
      if (item.children && item.children.length) {
        return getDefaultCheckedKeys(item.children, nodes)
      }
    }
  }

  const insertNodes = (department, nodes, isPoint) => {
    for (let item of department) {
      const departmentId = item.id
      const nodesFilter = nodes.filter(item => item?.department[0]?.id === departmentId).map(item => {
        return {
          ...item,
          title: item.name,
          key: item.id + '_' + Math.random() * 10,
          showicon: true,
          isLeaf: isPoint ? false : true,
          icon: <div style={{ width: 50, display: 'inline-block' }}>
            {
              <div style={{ ...(item.online ? onlineStyle : offlineStyle), ...iconStyle }}>{item.online ? '在线' : '离线'}</div>
            }
            <Icon svg={require('./../icon/NodeDark.svg')} />
          </div>,
          isNode: true,
          selectable: isPoint ? false : true
        }
      })
      item.key = item.id
      item.title = item.name
      if (item.child && item.child.length) {
        insertNodes(item.child, nodes, isPoint)
      }
      if (nodesFilter.length || (item.child && item.child.length)) {
        item.children = [...(item.child || []), ...nodesFilter]
      }
    }
    return department
  }

  const init = async () => {
    const nodes = await fetchNodes()
    await fetchDepartment(nodes, isPoint)
  }

  React.useEffect(() => {
    init()
  }, [model?.id, isPoint])

  React.useEffect(() => {
    const selectItems = filterDepartment(department, selectDepartment)
    const _department = formatDepartment(selectItems)
    const nodesList = _.keys(nodes).map(key => nodes[key])
    const noDepNodeList = _.filter(nodesList, (item) => _.isEmpty(item.department)).map(item => {
      return {
        ...item,
        title: item.name,
        key: item.id + '_' + Math.random() * 10,
        showicon: true,
        isLeaf: true,
        icon: <div style={{ width: 50, display: 'inline-block' }}>
          {
            <div style={{ ...(item.online ? onlineStyle : offlineStyle), ...iconStyle }}>{item.online ? '在线' : '离线'}</div>
          }
          <Icon svg={require('./../icon/NodeDark.svg')} />
        </div>,
        isNode: true,
        selectable: isPoint ? false : true
      }
    })
    const treeData = isShowAll ? [...insertNodes(_department, nodesList, isPoint), ...noDepNodeList] : insertNodes(_department, nodesList, isPoint)
    const _defaultCheckedKeys = getDefaultCheckedKeys(_treeData ? setData(_treeData) : treeData, nodes)
    setDefaultCheckedKeys(_defaultCheckedKeys)
    setExpandedKeys(isExpandAll ? selectItems.map(item=>item.id) : [])
    setState({
      models: selectItems,
      treeData: (_treeData || window[cellKey + '_treeData']) ? setData(mergeTreeData((_treeData || window[cellKey + '_treeData']), nodesList, noDepNodeList)) : (treeData[0]?.id == 'all' ? treeData : [{
        fullName: "全部",
        id: "all",
        key: "all",
        name: "全部",
        node: undefined,
        parent: {},
        title: "全部",
        uid: "all",
        users: undefined,
        children: treeData
      }]),
      loading: false
    })
    setAutoExpandParent(isExpandAll)
  }, [style, isShowAll, isExpandAll, isPoint])
  React.useEffect(() => {
    const selectItems = filterDepartment(department, selectDepartment)
    const _department = formatDepartment(selectItems)
    const nodesList = _.keys(nodes).map(key => nodes[key])
    const noDepNodeList = _.filter(nodesList, (item) => _.isEmpty(item.department)).map(item => {
      return {
        ...item,
        title: item.name,
        key: item.id + '_' + Math.random() * 10,
        showicon: true,
        isLeaf: true,
        icon: <div style={{ width: 50, display: 'inline-block' }}>
          {
            <div style={{ ...(item.online ? onlineStyle : offlineStyle), ...iconStyle }}>{item.online ? '在线' : '离线'}</div>
          }
          <Icon svg={require('./../icon/NodeDark.svg')} />
        </div>,
        isNode: true,
        selectable: isPoint ? false : true
      }
    })
    const treeData = isShowAll ? [...insertNodes(_department, nodesList, isPoint), ...noDepNodeList] : insertNodes(_department, nodesList, isPoint)
    const _defaultCheckedKeys = getDefaultCheckedKeys(treeData, nodes)
    setDefaultCheckedKeys(_defaultCheckedKeys)
    setExpandedKeys(isExpandAll ? selectItems.map(item=>item.id) : [])
    setState({
      models: selectItems,
      treeData: (treeData[0]?.id == 'all' ? treeData : [{
        fullName: "全部",
        id: "all",
        key: "all",
        name: "全部",
        node: undefined,
        parent: {},
        title: "全部",
        uid: "all",
        users: undefined,
        children: treeData
      }]),
      loading: false
    })
    setAutoExpandParent(isExpandAll)
  }, [JSON.stringify(selectDepartment)])

  const onCheck = React.useCallback((selectedKeys, e) => {
    const { checkedNodes } = e
    let values = []
    if (isPoint) {
      values = checkedNodes.filter(item => item.isTag).map((item) => {
        return tags.find(tag => item.id === tag.id && item?.node?.id === tag?.node?.id)
      })
    } else {
      values = checkedNodes.filter(item => item.isNode).map((item) => {
        return nodes[item.id]
      })
    }

    if (input && input.onChange) input.onChange(values)
  }, [model, nodes, tags, isPoint])

  const onSelect = (selectedKeys, e) => {
    if (single) {
      const { node: item } = e
      let value = null
      if (isPoint) {
        value = tags.find(tag => item.id === tag.id && item?.node?.id === tag?.node?.id)
      } else {
        value = nodes[item.id]
      }
      if (input && input.onChange) input.onChange(value)
    }
  }

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys)
    setAutoExpandParent(false)
  }

  const getMatchKeys = (value, treeData, result) => {
    for (let item of treeData) {
      if (item.isNode) {
        if (item.name.indexOf(value) !== -1) {
          result.push(item.key)
        }
      }
      if (item.children && item.children.length) {
        getMatchKeys(value, item.children, result)
      }
    }
  }

  const onSearch = (value) => {
    if (!value) {
      return
    }
    const result = []
    getMatchKeys(value, treeData, result)
    if (result.length) {
      setExpandedKeys(result)
      setAutoExpandParent(true)
    }
  }

  const LoadingOrReady = props => {
    const { ready } = props
    if (ready) {
      return (
        <Empty image={require('../icon/homeIcon/noData.png')} imageStyle={{ height: 100, marginTop: '20px' }}
          description={<span style={{ marginTop: '.5rem', display: 'inline-block' }}>未配置部门</span>}>
        </Empty>
      )
    } else {
      return <Spin style={{ width: '100%', marginTop: 20 }} />
    }
  }
  const onMouseDown = e => {
    if (editable) {
      e.stopPropagation()
    } else {
      e.preventDefault()
    }
  }
  const loop = (data, key, callback) => {
    data.forEach((item, index, arr) => {
      if (item.key == key) {
        return callback(item, index, arr);
      }
      if (item.children) {
        return loop(item.children, key, callback);
      }
    });
  };

  const getNodeList = (data) => {
    let _data = []
    data.map(node => {
      if (node?.children) {
        _data.push(getNodeList(node?.children))
      }
      if (!node?.children && node?.model) {
        _data.push(node)
      }
    })
    return _data
  }
  const onDrop = info => {
    const dropKey = info.node.props.eventKey; //拖拽元素到达的位置元素
    const dragKey = info.dragNode.props.eventKey; //被拖拽元素
    const dropPos = info.node.props.pos.split('-');
    const dropPosition =
      info.dropPosition - Number(dropPos[dropPos.length - 1]);

    let isContinue = false,
      isNodeParent = info.node.isNode,
      isNode = info.dragNode.isNode,
      nodeParent = info.node.parent?.id,
      dragNodeParent = info.dragNode.parent?.id
    const data = [...treeData];
    if (info.node.id == 'all') { // 目标为‘全部’节点
      if (!isNode && !dragNodeParent) isContinue = true  // 拖拽部门 被拖拽的部门属于全部
      if (isNode && !dragNodeParent && !info.dragNode?.department[0]?.id) isContinue = true   //  拖拽资产  被拖拽资产的父级是全部
    } else {
      if (!info.node.isNode) { // 目标为部门节点
        if (isNode) dragNodeParent = info.dragNode?.department[0]?.id
        if (!isNode && (dragNodeParent == nodeParent || dragNodeParent == info.node.id)) isContinue = true  //拖拽部门 且被拖拽节点属于目标节点或与目标节点同级
        if (isNode) {
          if (dragNodeParent == nodeParent && info?.node?.dragOverGapBottom) isContinue = true   // 同部门下 且 非拖拽至内部
          if (dragNodeParent == info.node.id && !info?.node?.dragOverGapBottom) isContinue = true
        } // 拖拽资产 且被拖拽节点属于目标节点或与目标节点同级
      } else {  // 目标为资产节点
        dragNodeParent = info.dragNode?.department ? info.dragNode?.department[0]?.id : dragNodeParent
        nodeParent = info.node?.department ? info.node?.department[0]?.id : nodeParent
        if (!isNode && (dragNodeParent == nodeParent) && info?.node?.dragOverGapBottom) isContinue = true  //拖拽部门 且被拖拽节点属于目标节点或与目标节点同级
        if (isNode && (dragNodeParent == nodeParent) && info?.node?.dragOverGapBottom) isContinue = true  // 拖拽资产 且被拖拽节点属于目标节点或与目标节点同级
      }
    }
    if (!isContinue) return
    // Find dragObject
    let dragObj;
    loop(data, dragKey, (item, index, arr) => {
      arr.splice(index, 1);
      dragObj = item;
    });
    if (!info.dropToGap) {
      // Drop on the content
      loop(data, dropKey, item => {
        item.children = item.children || [];
        // where to insert 示例添加到尾部，可以是随意位置
        if (dropPosition == 0) {
          item.children.unshift(dragObj);
        } else {
          item.children.push(dragObj);
        }
      });
    } else if (
      (info.node.props.children || []).length > 0 && // Has children
      info.node.props.expanded && // Is expanded
      dropPosition == 1 // On the bottom gap
    ) {
      loop(data, dropKey, item => {
        item.children = item.children || [];
        // where to insert 示例添加到尾部，可以是随意位置
        item.children.unshift(dragObj);
      });
    } else {
      let ar;
      let i;
      loop(data, dropKey, (item, index, arr) => {
        ar = arr;
        i = index;
      });
      if (dropPosition == -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }
    }
    setState({ treeData: data })

    // onChange(data);
  };
  const btnstyle = {
    backgroundColor: '#ccc',
    borderColor: '#ccc',
    borderRadius: 0,
    height: 30,
    width: 50,
    color: '#fff'
  }

  const addTags = (treeData, node, tags) => {
    for (let item of treeData) {
      if (item.isNode && item.key === node.key) {
        item.children = tags.map(tag => {
          return {
            ...tag,
            node,
            title: `${tag.name}（${tag.id}）`,
            key: tag.id + '_' + Math.random() * 10,
            showicon: true,
            isLeaf: true,
            icon: <Icon svg={require('./../icon/数据点选择器.svg')} />,
            isTag: true
          }
        })
        break
      }
      if (item?.children?.length) {
        addTags(item.children, node, tags)
      }
    }
    return treeData
  }

  const onLoadData = async (node) => {
    if (node.isNode) {
      const { json: _tags } = await api({ name: 'core/node/tag' }).fetch(`/${node.id}`, {})
      setTags([...tags, ..._tags.map(item => ({ ...item, node }))])
      const newTreeData = addTags(_.cloneDeep(treeData), node, _tags)
      setState({ ...state, treeData: newTreeData })
    }
    return
  }
  const getDep = (data) => {
    if (data?.length == 1 && data[0]?.id == 'all') {
      return data[0]?.children?.map(ele => {
        return {
          ...ele,
          children: getDep(ele.children)
        }
      })
    } else {
      let a = _.remove(_.cloneDeep(data), (item) => !item?.isNode)
      return a.map(item => {
        if (item.children) {
          return {
            ...item,
            children: getDep(item.children)
          }
        } else {
          return item
        }
      })
    }
  }

  const getDepPath = (data) => {
    return data.map(item => {
      if (item?.children) {
        return [item?.id, getDepPath(item?.children)]
      } else {
        return item?.id
      }
    })
  }
  const dom = models && !_.isEmpty(models) ? (
    <div style={{ height: '100%', overflow: 'auto' }} onMouseDown={onMouseDown} onMouseMove={e => editable && e.stopPropagation()} >
      {editMode ? <div style={{
        display: 'flex', flexWrap: 'wrap', alignItems: 'center', position: 'absolute',
        bottom: '100%', marginBottom: 1
      }}>
        <div style={{ margin: '0 2px 0 0', padding: 0, minHeight: 14 }}>
          <Tooltip title={editable ? '关闭拖拽' : '激活拖拽'}>
            <Button style={btnstyle} size="small" onClick={() => { setEditable(!editable) }}>
              <Icon svg={require(editable ? '../icon/解锁.svg' : '../icon/锁定.svg')} />
              {/* {editable ? '关闭鼠标交互' : '激活鼠标交互'} */}
            </Button>
          </Tooltip>
        </div>
        <div style={{ margin: 0, padding: 0, minHeight: 14 }}>
          <Tooltip title='保存资产树结构（需右上角再次保存才可记录）'>
            <Button style={btnstyle} size="small" onClick={() => {
              window[cellKey + '_treeData'] = treeData
              mergeParams(cellKey, {
                params: {
                  _treeData: treeData,
                  _nodeList: _.flattenDeep(getNodeList(treeData)),
                  _departmentPath: _.flattenDeep(getDepPath(getDep(treeData)))
                }
              })
            }}>
              {/* 保存资产树数据 */}
              <Icon svg={require('../icon/保存.svg')} />
            </Button>
          </Tooltip>

        </div>
      </div> : null}
      {
        treeData ? (
          <>
            <Search style={{ marginBottom: 8 }} placeholder="查询资产" onSearch={editable ? onSearch : null} />
            <div className="node-select-tree" >
              <Tree rootClassName="node-select-tree"
                showIcon
                showLine={{ showLeafIcon: false }}
                onCheck={onCheck}
                onExpand={onExpand}
                checkable={!single}
                draggable={editMode}
                onDrop={editable ? onDrop : null}
                selectable={single}
                onSelect={onSelect}
                treeData={treeData}
                defaultCheckedKeys={defaultCheckedKeys}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                loadData={onLoadData}
              >
              </Tree>
            </div>
          </>

        ) : <LoadingOrReady ready={ready} />
      }
    </div>
  ) : <LoadingOrReady ready={ready} />
  return dom
}

const paramSchema = {
  type: 'object',
  properties: {
    model: {
      title: '模型',
      type: 'array',
      fieldType: 'modelselect_multip',
      items: {},
    },
    selectDepartment: {
      title: '选择部门',
      type: 'array',
      items: {},
      field: {
        component: SelectDepartment
      }
    },
    isShowAll: {
      title: '展示无部门资产',
      type: 'boolean'
    },
    isExpandAll: {
      title: '默认展开全部',
      type: 'boolean'
    },
    style: {
      title: '在线状态',
      type: 'object',
      properties: {
        onlineText: {
          title: '在线文字',
          type: 'string',
          fieldType: 'color'
        },
        onlinebackground: {
          title: '在线背景',
          type: 'string',
          fieldType: 'color'
        },
        offlineText: {
          title: '离线文字',
          type: 'string',
          fieldType: 'color'
        },
        offlinebackground: {
          title: '离线背景',
          type: 'string',
          fieldType: 'color'
        },
      }
    },
    single: {
      title: '单选',
      type: 'boolean'
    },
    isPoint: {
      title: '显示数据指标',
      type: 'boolean'
    }
  },
  required: [],
  form: ['model',
    '*'
  ]
}

const NodeTreeSelect = {
  title: '资产选择树',
  category: '业务选择器',
  icon: require('../icon/资产导航树.svg'),
  component: NodeTree,
  paramSchema,
  fieldWidget: true,
  fieldWidgetType: 'pc',
  initParam: {
    autoHeight: true
  },
  initLayout: { width: 200, height: 500 }
}

export default NodeTreeSelect
export { NodeTree, SelectDepartment }
